<template>
  <div id="style-2" class="timeline">
    <div
      v-for="event in timelineEvents"
      :key="event.id"
      class="timeline-event d-flex mb-6"
    >
      <div class="mr-3">
        <div :style="{
              color: event.objectType === 'order_receipt' ? 'rgba(53, 183, 7, 1)' : 'rgba(255, 157, 115, 1)',
              height: '15px',
            }"
            >⦿</div>
        <div
            :style="{
              backgroundColor: event.objectType === 'order_receipt' ? 'rgba(53, 183, 7, 0.25)' : 'rgba(255, 223, 209, 1)',
              width: '2px',
              height: '90%',
              margin: 'auto'
            }"

        ></div>
      </div>
      <div class="w-100">
        <div class="timeline-event-header">
          <div class="d-flex justify-space-between" v-if="detailOrder.contactStatus">
            <div>
              <span class="mr-4">{{ formatDate(event.createdAt) }}  {{ event.objectType === 'order_receipt' ? '(Phiếu thu)' : '(Phiếu chi)' }}</span>
              <div
                v-if="haveSuccessOrder && checkStatusOrder(event.status)"
                class="cancel-order-history"
                @click="cancelOrder(event)"
              >
                HUỶ PHIẾU THU
              </div>
            </div>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="openDetailOrder(event)"
                    >mdi-text-box-search</v-icon
                  >
                </template>
                <span>Chi tiết phiếu</span>
              </v-tooltip>
            </div>
          </div>
          <div><strong>{{ event.code }}:
            <span :style="{
            color: event.objectType === 'order_receipt' ? 'rgba(53, 183, 7, 1)' : 'rgba(255, 157, 115, 1)',
            }">

            {{ (event.objectType === 'order_receipt' ? '' : '-') + formatCurrencyNoD(event.amount) }}
            </span>
          </strong>
            (VNĐ)</div>
        </div>
        <div class="timeline-event-header">
          <div>Phương thức thanh toán: <strong>{{ event.paymentMethod == 'MONEY_RECEIPT' ? 'Biên nhận' : event.paymentMethod }}</strong></div>
          <div>
            <span>Trạng thái thanh toán:</span>
            <span
              :style="{ color: checkSTATUS_PAY(event.status).color }"
              class="mx-2 text-uppercase"
              >{{ checkSTATUS_PAY(event.status).value }}</span
            >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="canShowQrButton(event)"
                  small
                  color="#0075ff"
                  class="pl-0 pr-0 min-w-[unset] w-auto qr-button"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="openQr(event)"
                >
                  <v-icon small>mdi-qrcode</v-icon>
                </v-btn>
              </template>
              <span>Thanh toán qua QR Code</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      v-if="isShowPopup"
      v-model="isShowPopup"
      max-width="1200"
    >
      <detail-history-order :detailData="selectionOrder" :detailOrder="detailOrder" :skuTutors="skuTutors" :skuDuos="skuDuos" :skuCombos="skuCombos" @close="isShowPopup = false"  />
    </v-dialog>
    <v-dialog
        v-if="isShowPopupPaymentSlip"
        v-model="isShowPopupPaymentSlip"
        max-width="1200"
    >

      <v-card style="background-color: #fafafa;">
        <div class="py-6 px-6">
          <h3 class="px-2">Thông tin phiếu chi {{ selectionOrder.code }}</h3>
          <div class="d-flex justify-space-between my-3 px-2">
            <div>
              <div class="mb-1">• Ngày tạo phiếu:
                <strong>{{ paymentSlip.paymentSlip && paymentSlip.paymentSlip.createdAt ? formatDate(paymentSlip.paymentSlip.createdAt) : '--' }}</strong>
              </div>
              <div class="mb-1" v-if="selectionOrder">• Ngày cập nhật cuối cùng:
                <strong>{{ paymentSlip.paymentSlip && paymentSlip.paymentSlip.updatedAt ? formatDate(paymentSlip.paymentSlip.updatedAt) : '--' }}</strong>
              </div>
            </div>
            <div>
              <div class="mb-1">• Sale tạo phiếu:
                <strong>{{ paymentSlip.user && paymentSlip.user.fullName ? paymentSlip.user.fullName : '--' }}</strong>
              </div>
              <div class="mb-1">• Trạng thái:
                <span
                    :style="{ color: checkSTATUS_PAY(selectionOrder.status).color }"
                    class="mx-2 text-uppercase font-weight-bold"
                >{{ checkSTATUS_PAY(selectionOrder.status).value }}</span
                >
              </div>
            </div>
          </div>
          <div style="background-color: #fff;border-radius: 4px;border: 1px solid rgba(170, 170, 170, 1)" class="px-2 py-3 mt-6">
            <div class="mb-1">
              • Giá trị phiếu chi:
              <span style="color: green" class="font-weight-bold">
                {{paymentSlip.paymentSlip ?  formatCurrencyNoD(paymentSlip.paymentSlip.amount)+ ' (đ)' : '-'}}</span>
            </div>
            <div class="mb-1">
              • Phương thức thành toán: <strong>{{ paymentSlip.paymentSlip && paymentSlip.paymentSlip.paymentMethod == 'MONEY_RECEIPT' ? 'Biên nhận' : paymentSlip.paymentSlip.paymentMethod }}</strong>
            </div >
            <div class="mb-1">• Đơn hàng gốc:  <span style="margin-left: 3px;">{{ paymentSlip.oldOrderCode || '-' }}</span></div>
            <div class="mb-1" v-if="paymentSlip.type === 'product_transference_payment_receipt'">• Đơn hàng đích:   <span style="margin-left: 3px;">{{ paymentSlip.newOrderCode  || '-'}} </span></div>
            <div class="mb-1" v-else>• Mã BNTT:   <span style="margin-left: 3px;">{{ paymentSlip.newOrderCode  || '-'}} </span></div>
          </div>
          <v-row class="mt-4">
            <v-col class="py-3" cols="6 ">
              <span class="font-weight-bold">
                <v-icon color="#0075ff"> mdi-message-text-outline </v-icon>
                <span style="margin-left: 5px;">GHI CHÚ</span>
              </span>
            </v-col>
            <v-col class="py-0" cols="12">
              <v-textarea
                  outlined
                  rows="3"
                  disabled
                  class="ma-0 pa-0 text-area-custom backgroundColorW"
                  :value="paymentSlip.orderReceiptNote ? paymentSlip.orderReceiptNote.noteSortClass : ''"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-end">

              <v-btn
                  class="btn-cancel mx-0"
                  color="#b70727"
                  height="38"
                  width="100"
                  @click="closePopupPaymentSlip()"
              >
                Đóng
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <qr-payment-modal v-model="showQr" :code="qrCode" :amount="qrAmount" :receipt-id="receiptId" />
  </div>
</template>

<script>
import moment from "moment";
import { STATUS_PAY } from "@/helpers/constants";
import DetailHistoryOrder from './DetailHistoryOrder.vue';
import QrPaymentModal from '@/components/common/QrPaymentModal.vue';
import OrderRepository from "../../../repositories/OrderRepository";
import { ORDER_OPERATION_TYPE } from "@/helpers/constants";
import TokenService from "@/helpers/token";

export default {
  components: { DetailHistoryOrder, QrPaymentModal },
  props: {
    timelineEvents: {
      type: Array,
      default: () => [],
    },
    detailOrder: {
      type: Object,
      default: () => {},
    },
    skuTutors: {
      type: Array,
      default: () => [],
    },
    skuDuos: {
      type: Array,
      default: () => [],
    },
    skuCombos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      STATUS_PAY,
      isShowPopup: false,
      isShowPopupPaymentSlip: false,
      selectionOrder: null,
      paymentSlip: {},
      showQr: false,
      qrCode: '',
      qrAmount: 0,
      receiptId: '',
    };
  },
  mounted() {
    if (typeof Bus !== 'undefined' && Bus) {
      Bus.$on('transfer-qr-code-success', this.handleTransferQrCodeSuccess);
    }
  },
  beforeDestroy() {
    if (typeof Bus !== 'undefined' && Bus) {
      Bus.$off('transfer-qr-code-success', this.handleTransferQrCodeSuccess);
    }
  },
  computed: {
    haveSuccessOrder() {
      const order = this.timelineEvents.find(
        (item) => item.status === "final_success"
      );
      if (order) {
        return true;
      }
      return false;
    },
  },
  methods: {
    handleTransferQrCodeSuccess(data = {}) {
      if (!this.showQr) {
        return;
      }
      const targetReceiptId = data && data.receiptId ? String(data.receiptId) : '';
      if (this.receiptId && targetReceiptId && String(this.receiptId) !== targetReceiptId) {
        return;
      }
      this.showQr = false;
    },
    closePopupPaymentSlip() {
      this.isShowPopupPaymentSlip = false
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("HH:mm:ss - DD/MM/YYYY");
      }
      return "";
    },
    checkSTATUS_PAY(status) {
      return this.STATUS_PAY.find((item) => item.key === status);
    },
    checkStatusOrder(status) {
      return ["init", "in_progress"].includes(status);
    },
    canShowQrButton(event) {
      if (this.detailOrder.metadata.operationType !== ORDER_OPERATION_TYPE.NORMAL_ORDER) {
        return false;
      }

      return (
        (
          (event.paymentMethod === 'COD' && (event.status === 'init' || event.status === 'in_progress')) ||
          (event.paymentMethod === 'BANK' && event.status === 'in_progress')
        ) &&
        Number(event.amount) > 0
      );
    },
    cancelOrder(item) {
      this.$swal({
        title:
          "Phiếu thu sẽ được hủy và không thể thực hiện thanh toán / đối soát.",
        confirmButtonText: "Xác nhận",
        showCancelButton: true,
        cancelButtonText: "Huỷ",
      }).then((res) => {
        if (res.value) {
          this.$emit("cancelOrder", item);
        }
      });
    },
    formatCurrencyNoD(val) {
      const cv = parseInt(val);
      const res =
        cv.toLocaleString("it-IT", { style: "currency", currency: "VND" }) ||
        "";
      return res.slice(0, -3);
    },
    async getPaymentSlip() {
      try {
        const response = await OrderRepository.getPaymentSlipApi(this.selectionOrder.id)
        if(response.success) {
          this.paymentSlip = response.data
        }else {
          this.paymentSlip = {}
        }
      }catch (e) {
        console.log(e)
      }
    },
    openDetailOrder(event) {
      this.selectionOrder = event
      if(event.objectType === 'order_receipt'){
        this.isShowPopup = true
      }else{
        this.isShowPopupPaymentSlip = true
        if(this.selectionOrder.id ) {
          this.getPaymentSlip()
        }
      }
    },
    openQr(event) {
      this.receiptId = event && event.id ? event.id : ''
      this.qrCode = event && event.code ? event.code : ''
      this.qrAmount = event && event.amount ? event.amount : 0
      this.showQr = true
    },
  },
};
</script>

<style scoped>
.cancel-order-history {
  cursor: pointer;
  color: #b70727;
  text-decoration: underline;
}
.timeline {
  display: flex;
  flex-direction: column;
  min-height: 210px;
  max-height: 260px;
  overflow-y: auto;
}

.timeline-event-header {
  align-items: center;
  font-weight: 400;
}

.timeline-event-date {
  font-size: 12px;
  color: gray;
}

.timeline-event-content {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}

.qr-button {
  transition: all 0.3s ease;
}

.qr-button:hover {
  background-color: transparent !important;
  border: 1px solid #0075ff !important;
  color: #0075ff !important;
}

.qr-button:hover .v-icon {
  color: #0075ff !important;
}
</style>
